import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { PageLoading } from "../../components/PageLoading";
import { useDrokAccess } from "../use-drok-access";

/** Lets IT through to the admin pages. The server checks every call too; this only keeps employees out of the screens. */
export function AdminGate({ children }: { children: ReactNode }) {
  const access = useDrokAccess();
  if (access === "loading") return <PageLoading />;
  if (access === "employee") return <Navigate to="/app" replace />;
  return children;
}
